// Third party

// Utils
import { routes } from '@routes';
import { SearchPageContentType, SearchPageParagraphType } from '@gql';

// UI
import { SerpParagraph } from './serp-paragraph';
import { SearchLinks, SearchPageLinkType } from './search-links';
import { SearchPageContentPartial } from '@pages-components/seo-serp-page/seo-serp-page';
import { Typography } from '@components/typography';

type Props = { searchPageContent?: SearchPageContentPartial };

export const SearchPageContentFooter: React.FC<Props> = ({
  searchPageContent,
}) => {
  if (!searchPageContent) {
    return null;
  }

  const aboutParagraphs = searchPageContent.searchPageParagraphs.filter(
    (s) => s.type === SearchPageParagraphType.About
  );

  const faqParagraphs = searchPageContent.searchPageParagraphs.filter(
    (s) => s.type === SearchPageParagraphType.Faq
  );

  const cityLinks = searchPageContent.cities
    .filter((city) => city.region !== undefined)
    .map((city) => {
      let region = city.region!;
      var path = '';
      switch (city.searchType) {
        case SearchPageContentType.VacationRental:
          path = routes.seoVRSearchShow(region);
          break;
      }
      return {
        href: path,
        title: region.description,
        type: SearchPageLinkType.City,
      };
    });

  const links = searchPageContent.searchPageLinks.map((link) => {
    return {
      href: link.href,
      title: link.title,
      type: link.type,
    };
  });

  const pageLinks = cityLinks
    .filter((link) => link !== undefined)
    .concat(links);

  return (
    <div className="relative space-y-4 px-2 sm:px-0">
      {/* explore */}
      <div className="py-4 w-full">
        <Typography component="h2" variant="title3" className="mb-4">
          {searchPageContent.h2}
        </Typography>
        <Typography
          component="p"
          className="text-black text-left text-md whitespace-pre-line"
        >
          {searchPageContent.h2ParagraphRaw}
        </Typography>
      </div>

      {aboutParagraphs.length > 0 && (
        <div>
          {searchPageContent.aboutItemsTitle && (
            <Typography component="h2" variant="title1" className="mt-4">
              {searchPageContent.aboutItemsTitle}
            </Typography>
          )}
          <ul className="flex flex-col divide-gray-light divide-y-2">
            {aboutParagraphs.map((aboutParagraph, index) => (
              <SerpParagraph
                key={index}
                title={aboutParagraph.title}
                bodyRaw={aboutParagraph.bodyRaw}
              />
            ))}
          </ul>
        </div>
      )}

      {faqParagraphs.length > 0 && (
        <div>
          <Typography
            component="h3"
            variant="title2"
            className="z-10 py-4 text-left text-black"
          >
            {searchPageContent.faqsTitle
              ? searchPageContent.faqsTitle
              : `${searchPageContent.h1} FAQ`}
          </Typography>

          <ul className="flex flex-col divide-gray-light divide-y-2">
            {faqParagraphs.map((faqParagraph, index) => (
              <SerpParagraph
                key={index}
                title={faqParagraph.title}
                bodyRaw={faqParagraph.bodyRaw}
              />
            ))}
          </ul>
        </div>
      )}

      {pageLinks.length > 0 && <SearchLinks searchPageLinks={pageLinks} />}
    </div>
  );
};
